import { p as proxyCustomElement, H, c as createEvent, h, a as Host } from './index.js';
import { d as defineCustomElement$9 } from './p-BbTg3Car.js';
import { d as defineCustomElement$8 } from './p-D5W-FK48.js';
import { d as defineCustomElement$7 } from './p-CgjIzafk.js';
import { d as defineCustomElement$6 } from './p-BDIehgMZ.js';
import { d as defineCustomElement$5 } from './p-lnuA9A6c.js';
import { d as defineCustomElement$4 } from './p-CW-Ftoto.js';
import { d as defineCustomElement$3 } from './p-Trmgzgcp.js';
import { d as defineCustomElement$2 } from './p-KbTC_jnR.js';

const expandableTileCss = ".header-wrapper{align-items:center;background:none;border:none;color:inherit;cursor:pointer;display:inline-flex;font-size:inherit;justify-content:flex-start;margin:0;padding:0;width:100%}.header-wrapper:disabled{cursor:not-allowed}.header-addon-wrapper{display:flex;gap:.5rem}:host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;border:1px solid var(--jw-theme-surface-border-border-color);border-radius:.375rem;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host header{align-items:center;background:var(--jw-theme-surface-tile-bg-color);border-radius:.375rem;display:flex;justify-content:space-between;padding:1.5rem;width:100%}:host .body-container{background-color:var(--jw-theme-surface-tile-bg-color);display:none;flex-direction:column;padding:1.5rem}:host .footer-container{padding-top:1rem}:host h3{color:var(--jw-theme-surface-text-default-color);font-family:Open Sans;font-size:1.125rem;font-weight:400;letter-spacing:-.0008em;line-height:1.5rem;margin:0}:host h4{color:var(--jw-theme-surface-text-default-color);font-family:Open Sans;font-size:1rem;font-weight:600;letter-spacing:-.0008em;line-height:1.5rem;margin:0}:host .property-slots-container{display:flex;gap:1rem}:host .property-slots-chevron-group{align-items:center;display:flex;gap:1rem}:host .property-slot{align-items:center;color:var(--jw-theme-surface-text-description-color);display:flex}:host .tile-content{background-color:var(--jw-theme-surface-tile-bg-color)}:host .content{display:flex;flex-direction:column;gap:1.5rem}:host([expanded]) .body-container{border-bottom-left-radius:.375rem;border-bottom-right-radius:.375rem;display:flex}:host([expanded]) header{border-bottom:1px solid var(--jw-theme-surface-border-border-color);border-bottom-left-radius:0;border-bottom-right-radius:0}:host([nested]) header{background:var(--jw-theme-surface-level1-default-bg-color)}:host([nested]) .body-container{background-color:var(--jw-theme-surface-level1-default-bg-color);border-radius:.375rem}:host([nested]) .body-container,:host([nested]) .footer-container,:host([nested]) .tile-content{background-color:var(--jw-theme-surface-level1-default-bg-color)}";

const WuiExpandableTile$1 = /*@__PURE__*/ proxyCustomElement(class WuiExpandableTile extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.expandedChange = createEvent(this, "expandedChange", 7);
        /**
         * Expandable header title
         */
        this.header = '';
        /**
         * Array of Property Slots. These can either be a String to display or a WuiStatus object
         */
        this.propertySlots = [];
        this.nested = false;
        this.expanded = false;
        this.disabled = false;
        this.toggleExpanded = () => {
            if (this.disabled) {
                return;
            }
            this.expanded = !this.expanded;
            this.expandedChange.emit(this.expanded);
        };
        this.renderPropertySlot = (propertySlot) => {
            if (propertySlot === null || propertySlot === undefined || propertySlot === '') {
                return null;
            }
            if (typeof propertySlot === 'string') {
                return h("span", { class: "property-slot" }, propertySlot);
            }
            return h("wui-status", { ...propertySlot });
        };
        this.hasFooter = () => {
            return this.elm.querySelector('[slot="footer"]') !== null;
        };
    }
    render() {
        const slotsWithDividers = [];
        const defaultBoxProps = {
            padding: 0,
        };
        const boxProps = typeof this.contentBox === 'object' ? this.contentBox : {};
        this.propertySlots.forEach((propertySlot, index) => {
            slotsWithDividers.push(this.renderPropertySlot(propertySlot));
            if (index !== this.propertySlots.length - 1) {
                slotsWithDividers.push(h("wui-divider", { type: "vertical" }));
            }
        });
        return (h(Host, { key: 'bd48d9a96f850635044c5cee2802e6be37778893' }, h("button", { key: 'a1579595245a056ab2248a20ba511d4ef8b151e4', type: "button", class: "header-wrapper", disabled: this.disabled, onClick: this.toggleExpanded }, h("header", { key: 'b72a1e4eb48e5bc47a7b3a9a806af241eb125a01' }, h("div", { key: 'e9f9606f08269943141a6ff2e99853c526afb357', class: "header-addon-wrapper" }, this.nested ? h("h4", null, this.header) : h("h3", null, this.header), h("slot", { key: 'b27f6de6c63cacadf5ab4a58ff272cd4f9ba56d1', name: "header-addon" })), h("div", { key: '8fc5e5649689ee6ab3567a30686eaea0e4736210', class: "property-slots-chevron-group" }, h("div", { key: '4d9359929ac643275e8669a190a0f7fd0482fc46', class: "property-slots-container" }, slotsWithDividers), h("wui-button", { key: '77cd619dde62d131a0d8100e74c48d5228a1296f', type: "icon-ghost", icon: this.expanded ? 'chevron-up' : 'chevron-down', tooltip: this.expanded ? 'Collapse' : 'Expand', disabled: this.disabled })))), h("div", { key: '1dbdd4bdcd770dac60f3537899fe2623d45db9fd', class: "body-container" }, h("div", { key: 'd8386a08433f66ca55ad1ccd27d722796a06f1b7', class: "content" }, h("wui-box", { key: '944f05607fe591b30e40562e8700b7a025c03751', style: { flex: '1' }, ...defaultBoxProps, ...(this.expanded ? boxProps : { ...boxProps, padding: 0 }) }, h("slot", { key: '98631d195c1c36f9477be79dd46e696c6d24063b' })), this.hasFooter() && h("wui-divider", { key: '689baba0ab3ef3d447fb9e852b0b421645744b2d', type: "horizontal" })), this.hasFooter() && (h("div", { key: '861430d5d622524297065fe4aefbc4229e966d80', class: "footer-container" }, h("slot", { key: 'fad375192306de368726ca39a6cc8f96c274b8a7', name: "footer" }))))));
    }
    get elm() { return this; }
    static get style() { return expandableTileCss; }
}, [257, "wui-expandable-tile", {
        "contentBox": [4, "content-box"],
        "header": [1],
        "propertySlots": [16, "property-slots"],
        "nested": [516],
        "expanded": [1540],
        "disabled": [516]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-expandable-tile", "wui-box", "wui-button", "wui-divider", "wui-icon", "wui-loader", "wui-status", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-expandable-tile":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiExpandableTile$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiExpandableTile = WuiExpandableTile$1;
const defineCustomElement = defineCustomElement$1;

export { WuiExpandableTile, defineCustomElement };
